/**
 * Created by wawei on 2019-03-08.
 */
import React, { Component } from "react";
import Loading from "./Loading.js";
import { URL } from "../../common/Constants.js";

class Switching extends Component {
  componentDidMount() {
    setTimeout(() => {
      this.props.history.replace(URL.DISPATCH);
    }, 100);
  }

  render() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
          bottom: 0,
          left: 0,
          margin: "auto",
          position: "absolute",
          right: 0,
          top: 0
        }}
      >
        <div
          style={{
            width: "100%",
            height: "20px",
            display: "inline-block",
            marginTop: "20%"
          }}
        >
          <Loading size="large" tip="Loading..." />
        </div>
      </div>
    );
  }
}

export default Switching;



// WEBPACK FOOTER //
// ./src/common/components/Switching.js